import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import recommendationIcon from 'src/assets/icons/recommendation.svg';

export type IrisPickBadgeProps = {
  /** Sizing follows the badge font size, so overriding `fontSize` scales the icon along with it. */
  className?: string;
};

const useStyles = makeStyles((theme) => ({
  badge: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    padding: '0.15em 2.3em 0.15em 0.75em',
    borderRadius: 13,
    backgroundColor: theme.palette.intelligence.main,
    color: theme.palette.common.white,
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 1.5,
    whiteSpace: 'nowrap',
  },
  icon: {
    position: 'absolute',
    right: '-1px',
    top: '50%',
    transform: 'translateY(-50%)',
    // content-box keeps the padding outside the icon, so it widens the disc instead of shrinking the seal.
    boxSizing: 'content-box',
    width: '1.6em',
    height: '1.6em',
    padding: '0.25em',
    borderRadius: '50%',
    // The seal is violet, so it needs a light disc to stay readable on the violet badge.
    backgroundColor: theme.palette.common.white,
  },
}));

/**
 * Violet "IRIS-Pick" badge marking a vehicle as an IRIS purchase recommendation.
 * Shared by the vehicle list and the car detail page so both stay recognisable as the same feature.
 */
const IrisPickBadge = ({ className }: IrisPickBadgeProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <span className={clsx(classes.badge, className)}>
      {t('recommendationsPage.irisRecommends')}
      <img src={recommendationIcon} className={classes.icon} alt="" />
    </span>
  );
};

export default IrisPickBadge;
